export const SettingsQueryKeys = {
    all: ['settings'],
    settings: () => [...SettingsQueryKeys.all, 'setting'],
    setting: (id: number) => [...SettingsQueryKeys.settings(), id],
  };